<div class="bank-icons tw-flex tw-w-[95px] tw-justify-end">
  <div class="tw-relative tw-flex tw-w-full md:tw-h-auto">
    <div
      *ngFor="let bank of banks; let i = index"
      class="bank icon {{ bank }} tw-absolute tw-shadow-icon position-{{ i }}"
    ></div>
    <div
      class="icon tw-z-2 position-3 tw-relative tw-rounded-full tw-bg-dt-surface-elevated tw-text-center tw-shadow-icon"
    >
      <svg [attr.class]="svgClass">
        <use [attr.xlink:href]="'images/sprite.svg#' + iconName"></use>
      </svg>
    </div>
  </div>
</div>
